import { Autocomplete, TextField } from '@mui/material';
import { customPalette } from '../../../themes/customTheme';

export const CustomSelect = ({
  value,
  setValue,
  field,
  items,
  label,
  disabled = false,
  disableClearable = false,
}) => {
  return (
    <Autocomplete
      id={label}
      options={items}
      noOptionsText="Sin resultados"
      getOptionLabel={option => (option?.[field] ? option[field] : '')}
      value={items.find(item => item[field] === value) || null}
      onChange={(event, newValue) => {
        setValue(newValue ? newValue[field] : '');
      }}
      size="small"
      sx={{ minWidth: 200 }}
      disabled={disabled}
      disableClearable={disableClearable}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          sx={{
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: customPalette.primary.main,
              },
              '&.Mui-focused fieldset': {
                borderColor: customPalette.primary.main,
              },
            },
            '& .MuiInputLabel-root': {
              '&.Mui-focused': {
                color: customPalette.primary.main,
              },
            },
          }}
        />
      )}
      componentsProps={{
        popper: {
          sx: {
            '& .MuiPaper-root': {
              border: `1px solid ${customPalette.primary.main}`,
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              marginTop: '4px',
            },
          },
        },
      }}
    />
  );
};
